export default "__VITE_ASSET__DaTWzFOC__"